const apiBaseUrl = "https://opentdb.com/api.php?";

export const getQuizQuestions = async (numberOfQuestions: number, category: string, difficulty: string) => {
  const response = await fetch(
    `${apiBaseUrl}amount=${numberOfQuestions}&category=${category}&difficulty=${difficulty}&type=multiple`
  );
  return await response.json();
};
